import { render, staticRenderFns } from "./listado_pedidos2.vue?vue&type=template&id=24c28445&scoped=true"
import script from "./listado_pedidos2.vue?vue&type=script&lang=js"
export * from "./listado_pedidos2.vue?vue&type=script&lang=js"
import style0 from "./listado_pedidos2.vue?vue&type=style&index=0&id=24c28445&prod&lang=scss&scoped=true"
import style1 from "./listado_pedidos2.vue?vue&type=style&index=1&id=24c28445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28445",
  null
  
)

export default component.exports